import EditorStore from "./editor/editor";

class RootStore {
    constructor() {
        this.editor = new EditorStore(this);
    }
}

export default RootStore;